<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card class="card">
            <h4 class="text-center">Alternative Match Names</h4>
            <div class="row">
              <div class="col-md-6 text-left">
              <a href="#" @click.prevent="refreshNames()"
                ><em
                  class="tim-icons icon-refresh-02"
                  :class="refreshingAnimation"
                  style="font-size: 22px; margin-bottom: 10px; margin-top: 10px"
                ></em
              ></a>
              <span style="margin-left: 20px; font-size: 18px;" class="mt-8"
                >Refreshed at {{ lastRefreshedAt }}</span
              >
              </div>
              <div class="col-md-6 text-right">
                <button type="button" class="btn btn-primary mb-4 float-right" @click="showAddNameModal = true; formAction = 'Add'">
                  New Alternative Name
                </button>
              </div>
            </div>
            <vue-good-table
                :columns="columns"
                :rows="names"
                theme="nocturnal"
                :search-options="{
                    enabled: true
                }"
                :pagination-options="{
                    enabled: true,
                    perPage: 15,
                    allLabel: 'All',
                }"
                >
                <div slot="emptystate">
                    <div v-show="isLoading" class="progress-horizontal">
                    <div class="bar-horizontal"></div>
                    </div>
                    <span v-show="!isLoading">
                    There are no matches currently. Check back later 😉
                    </span>
                </div>
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'actions'">
                    <base-button icon round @click="duplicateAlternativeMatchName(props.row)">
                      <i class="tim-icons icon-single-copy-04"></i>
                    </base-button>
                    <base-button icon round @click="editAlternativeMatchName(props.row)" class="ml-4">
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                    <base-button icon round @click="deleteAlternativeMatchName(props.row.id)" class="ml-4">
                      <i class="tim-icons icon-trash-simple"></i>
                    </base-button>
                  </span>
                  <span v-else-if="props.column.field == 'created_at'">
                    {{formatDateTime(props.row.created_at)}}
                  </span>
                  <span v-else-if="props.column.field == 'updated_at'">
                    {{formatDateTime(props.row.updated_at)}}
                  </span>

                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
            </vue-good-table>
            <dashboard-section-links />
            <add-alternative-match-dialog :showAddNameModal="showAddNameModal" :form="form" :formAction="formAction" @close="showAddNameModal = false; resetForm()" @added="getNames()" />
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import formatDateTime from "../mixin/formatDateTime";
import AddAlternativeMatchDialog from '@/components/AddAlternativeMatchDialog.vue';
import DashboardSectionLinks from '@/components/DashboardSectionLinks.vue';

export default {
    components: {
      AddAlternativeMatchDialog,
      DashboardSectionLinks
    },
    mixins: [formatDateTime],
    data() {
        return {
          isLoading: true,
          isRefreshing: false,
          isAddAlternativeNameLoading: false,
          showAddNameModal: false,
          refreshingAnimation: "",
          lastRefreshedAt: this.formatTime(new Date()),
          names: [],
          columns: [
            { label: 'Bookie', field: 'bookie' },
            { label: 'Category', field: 'category' },
            { label: 'Match Name', field: 'match_name' },
            { label: 'Alternative Name', field: 'alternative_name' },
            { label: "Created at", field: "created_at" },
            { label: "Updated at", field: "updated_at" },
            { label: 'Actions', field: 'actions' }
          ],
          form: {
            bookie: '',
            match_name: '',
            alternative_name: '',
            alternative_names: {
              home_team: '',
              away_team: '',
            },
            category: '',
            provider: '',
            has_error : false,
            error_message : '',
          },
          formAction: 'Add',
      }
    },
    computed: {
      currentRouteName () {
        return this.$route.name
      }
    },
    watch: {
      isRefreshing() {
        if (this.isRefreshing) {
          this.refreshingAnimation = "rotating";
        } else {
          this.refreshingAnimation = "";
        }
      },
    },
    methods: {
        getNames() {
            this.isLoading = true
            axios.get('alternative-game-names')
            .then(response => {
                this.names = response.data
                this.isLoading = true
                this.isRefreshing = false
                this.lastRefreshedAt = this.formatTime(new Date());
            })
            .catch(error => {
                // handle error
                console.log(error);
                this.isRefreshing = false;
            });
      },
      duplicateAlternativeMatchName(match) {
        this.formAction = 'Add'
        this.form.id = match.id
        this.form.bookie = match.bookie
        this.form.match_name = match.match_name
        this.form.alternative_name = match.alternative_name
        this.form.category = this.slugToTitleCase(match.category)
        this.form.provider = match.provider
        this.showAddNameModal = true
      },
      editAlternativeMatchName(match) {
        this.formAction = 'Edit'
        this.form.id = match.id
        this.form.bookie = match.bookie
        this.form.match_name = match.match_name
        this.form.alternative_name = match.alternative_name
        this.form.category = this.slugToTitleCase(match.category)
        this.form.provider = match.provider
        this.showAddNameModal = true
      },
      deleteAlternativeMatchName(id) {
        axios.delete('alternative-game-names/' + id)
        .then(response => {
            this.getNames()
        })
        .catch(error => {
            // handle error
            console.log(error);
        });
      },
      resetForm() {
        this.form.bookie = ''
        this.form.match_name = ''
        this.form.alternative_name = ''
        this.form.category = ''
        this.form.provider = ''
        this.form.has_error = false
        this.form.error_message = ''
      },
      slugToTitleCase(slug) {
        if (!slug) {
          return '';
        }
        const words = slug.split('-');
        const titleCaseWords = words.map(word => {
          return word[0].toUpperCase() + word.slice(1).toLowerCase();
        });

        return titleCaseWords.join(' ');
      },
      refreshNames() {
        this.isRefreshing = true;
        this.getNames();
      },
    },
    mounted() {
        this.getNames()
    }
  };
</script>
<style>
.my-select {
  background-color: #1e1e2e;
  color: #ffffff;
  padding: 6px 20px;
}
.my-select option {
  background-color: #1e1e2e;
  color: #ffffff;
}
.white-background {
  background-color: #ffffff;
}
@keyframes spinner {
  0% {
    width: 0;
  }
  50% {
    width: 100%;
    margin-left: 50%;
  }
  100% {
    width: 0;
    margin-left: 100%;
  }
}
.rotating {
  -webkit-animation: rotation 2s infinite linear;
  animation: rotation 2s infinite linear;
}
@keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
</style>
